import { Flex } from '@podiumhq/design-system';

import { usePricingPackagingContext } from 'contexts/PricingPackagingContextProvider';

import BundleCard from '../../components/BundleCard';
import { BUNDLE_PACKAGES_LIST, PACKAGE_NAME_VARIATIONS } from '../../constants';
import { getBundleCardProps } from '../../utils';

export const SelectPlanBundleCards = ({
  bundlePackages = BUNDLE_PACKAGES_LIST,
  ...wrapperStyleProps
}) => {
  const {
    canChoosePlan,
    isMobileView,
    monthlyPackagePrices = {},
    onBundleCardCtaOnClick,
    priceTerm,
    yearlyPackagePrices = {},
  } = usePricingPackagingContext();

  const getAnnualAndMonthlyBundlePrices = (bundleName) => {
    const standardizeBundleName = PACKAGE_NAME_VARIATIONS[bundleName];
    const annualPrice = yearlyPackagePrices[standardizeBundleName];
    const monthlyPrice = monthlyPackagePrices[standardizeBundleName];

    return { annualPrice, monthlyPrice };
  };

  const onBundleCardCtaOnClickWithPrices = (bundleName) => {
    const prices = getAnnualAndMonthlyBundlePrices(bundleName);
    onBundleCardCtaOnClick(bundleName, prices);
  };

  return (
    <Flex
      align={isMobileView ? 'center' : 'flex-end'}
      boxSizing="border-box"
      direction={isMobileView ? 'column' : 'row'}
      justify="space-between"
      minWidth="0"
      width="100%"
      {...wrapperStyleProps}
    >
      {bundlePackages.map((bundleName) => (
        <BundleCard
          key={bundleName}
          handleCtaOnClick={
            onBundleCardCtaOnClick
              ? () =>
                  canChoosePlan
                    ? onBundleCardCtaOnClickWithPrices(bundleName)
                    : onBundleCardCtaOnClick(bundleName, priceTerm)
              : null
          }
          {...getBundleCardProps(bundleName)}
        />
      ))}
    </Flex>
  );
};
